import { Link } from "@inertiajs/react";
import { ComponentType } from "react";

interface EmptyStateProps {
  icon: ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  actionUrl?: string;
  actionText?: string;
  actionIcon?: ComponentType<{ className?: string }>;
  onAction?: () => void;
  actionDisabled?: boolean;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionUrl,
  actionText,
  actionIcon: ActionIcon,
  onAction,
  actionDisabled = false,
}: EmptyStateProps) {
  return (
    <div className="p-6 text-center">
      <div className="max-w-sm mx-auto">
        <div className="w-10 h-10 mx-auto mb-3 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon className="w-5 h-5 text-primary" />
        </div>
        <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-1">
          {title}
        </h3>
        {description && (
          <p className="text-xs text-gray-600 dark:text-gray-400 mb-3">
            {description}
          </p>
        )}
        {actionText && (
          <>
            {actionUrl ? (
              <Link
                href={actionUrl}
                className="inline-flex items-center justify-center gap-1.5 px-3 py-1.5 bg-primary text-white text-xs font-medium rounded-full hover:bg-primary/90 transition-colors"
              >
                {ActionIcon && <ActionIcon className="w-3.5 h-3.5" />}
                {actionText}
              </Link>
            ) : onAction ? (
              <button
                onClick={onAction}
                disabled={actionDisabled}
                className="inline-flex items-center justify-center gap-1.5 px-3 py-1.5 bg-primary text-white text-xs font-medium rounded-full hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {ActionIcon && <ActionIcon className="w-3.5 h-3.5" />}
                {actionText}
              </button>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}